import React from 'react';
import PropTypes from 'prop-types';

const LegendBlock = ({ title, children }) => (
   <div className="legend-block">
      <span className="legend-block__title">{title}</span>

      <div>
         {children}
      </div>
   </div>
);

LegendBlock.propTypes = {
   title: PropTypes.string
};

export default LegendBlock;
